if (!customElements.get("bundle-builder")) {
  customElements.define(
    "bundle-builder",

    class BundleBuilder extends HTMLElement {
      constructor() {
        super();

        this.bundlePickers = Array.from(
          this.querySelectorAll("bundle-product-picker")
        );

        this.addToCartForm = this.querySelector("bundle-add-to-cart form");

        this.addToCartElement = this.querySelector(
          "bundle-add-to-cart [type='submit']"
        );

        this.init();
      }

      init() {
        this.bundlePickers.forEach((picker) =>
          picker.addEventListener(
            "itemSelected",
            this.validateBundle.bind(this)
          )
        );

        this.addToCartElement.addEventListener(
          "click",
          this.hanldeAddToCart.bind(this)
        );
      }

      validateBundle(event) {
        const picker = event.target;
        const selectedVariantDetails = event.detail;

        if (selectedVariantDetails.productType == "regular") {
          picker.querySelector("details").removeAttribute("open");
        }

        if (picker.nextElementSibling.nodeName === "BUNDLE-PRODUCT-PICKER") {
          if (
            picker.nextElementSibling.getAttribute("product-type") === "regular"
          ) {
            picker.nextElementSibling
              .querySelector("details")
              .setAttribute("open", true);
          }
        }

        this.addSelectedItemsToBundle(selectedVariantDetails);
      }

      hanldeAddToCart(event) {
        this.bundlePickers.forEach((picker) => {
          if (picker.getAttribute("picked") === null) {
            event.preventDefault();
            picker.classList.add("error");
          } else {
            picker.classList.remove("error");
          }
        });
      }

      addSelectedItemsToBundle(itemData) {
        const existingInputElement = this.addToCartForm.querySelector(
          `[name='items[${itemData.index}]id']`
        );

        if (existingInputElement) {
          existingInputElement.value = itemData.itemId;
        } else {
          const inputElement = document.createElement("input");
          inputElement.setAttribute("class", "item-id");
          inputElement.setAttribute("type", "hidden");
          inputElement.setAttribute("name", `items[${itemData.index}]id`);
          inputElement.setAttribute("value", itemData.itemId);

          this.addToCartForm.appendChild(inputElement);
        }

        if (itemData.productType == "free") {
          const existingQuantityElement = this.addToCartForm.querySelector(
            `[name='items[${itemData.index}]quantity']`
          );

          if (existingQuantityElement) {
            existingQuantityElement.value = itemData.quantity;
          } else {
            const inputElement = document.createElement("input");
            inputElement.setAttribute("class", "item-quantity");
            inputElement.setAttribute("type", "hidden");
            inputElement.setAttribute(
              "name",
              `items[${itemData.index}]quantity`
            );
            inputElement.setAttribute("value", itemData.quantity);

            this.addToCartForm.appendChild(inputElement);
          }
        }
      }
    }
  );
}

if (!customElements.get("bundle-product-picker")) {
  customElements.define(
    "bundle-product-picker",

    class BundleProductPicker extends HTMLElement {
      constructor() {
        super();

        this.productType = this.getAttribute("product-type");

        this.itemInputElements = Array.from(
          this.querySelectorAll(".bundle-item-input-element")
        );

        this.init();
      }

      init() {
        this.itemInputElements.forEach((item) =>
          item.addEventListener("click", this.handleItemSelection.bind(this))
        );
      }

      handleItemSelection(event) {
        this.unselectAllItems();

        const item = event.target;
        const index = item.getAttribute("data-item-index");
        const itemId = item.getAttribute("data-variant-id");
        const quantity = item.getAttribute("data-item-quantity");

        item.checked = true;
        this.classList.remove("error");
        this.setAttribute("picked", true);

        if (this.productType == "regular") {
          this.handleRegularProductTasks(item);
        } else {
          this.handleFreeProductTasks(item);
        }

        const itemSelected = new CustomEvent("itemSelected", {
          detail: {
            itemId,
            index,
            quantity,
            productType: this.productType,
          },
        });

        this.dispatchEvent(itemSelected);
      }

      handleRegularProductTasks(item) {
        this.itemNameElement = this.querySelector(
          ".bundle-product-picker--selected-item-name"
        );
        const variantName = item.getAttribute("data-variant-title");
        this.itemNameElement.textContent = variantName;
      }

      handleFreeProductTasks(item) {
        this.itemImageElement = this.querySelector(
          ".free-product-picker--image-container img"
        );
        const variantImage = item.getAttribute("data-variant-image");
        this.itemImageElement.src = variantImage;
      }

      unselectAllItems() {
        this.itemInputElements.forEach((item) => (item.checked = false));
      }
    }
  );
}
